<header>
  <div class="content">
    <a routerLink="/" aria-label="Home Page">
      <app-logo [size]="38"></app-logo>
      <app-site-name></app-site-name>
    </a>
    <div class="spacer"></div>
    <a matIconButton aria-label="cart button" routerLink="/shopping/cart">
      <mat-icon fontSet="material-symbols-outlined">shopping_bag</mat-icon>
    </a>
  </div>
</header>
<div class="content">
  <div class="left">
    <div class="form">
      <h3>
        <span>Contact</span>
        @if (!profile) {
        <a routerLink="/login" aria-label="login">Login</a>
        }
      </h3>
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="Email"
          type="email"
          [(ngModel)]="email"
          autocomplete="off"
        />
      </mat-form-field>
      <h3>Payment</h3>
      <div class="payment" #payment>
        <nz-skeleton [nzActive]="true"></nz-skeleton>
      </div>
      <h3>
        <span>Shipping Address</span>
        <app-select-user-shipping-address-button
          (onSelected)="onAddressSelected($event)"
        ></app-select-user-shipping-address-button>
      </h3>
      <div class="shipping-address" #shippingAddress>
        <nz-skeleton [nzActive]="true"></nz-skeleton>
      </div>

      <app-button
        type="filled"
        (onClick)="pay()"
        [disabled]="!stripe || !stripeElements || !user_payment_intent"
        [loading]="loading"
        >Pay Now</app-button
      >
    </div>
  </div>
  <div class="right">
    @if (user_payment_intent) {
    <div class="form">
      <app-checkout-summary
        [user_payment_intent]="user_payment_intent"
      ></app-checkout-summary>
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Summary </mat-panel-title>
            <mat-panel-description>
              <app-price [price]="user_payment_intent.total"></app-price>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-checkout-summary
            [user_payment_intent]="user_payment_intent"
          ></app-checkout-summary>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    }
  </div>
</div>
